import script from "./ReleaseUpdatesLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./ReleaseUpdatesLoader.vue?vue&type=script&setup=true&lang=js"

import "./ReleaseUpdatesLoader.vue?vue&type=style&index=0&id=0ccfc2a0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ccfc2a0"]])

export default __exports__